
import _ from 'lodash'
import eventBus from './eventBus'
import { isAndroid, isIOS } from './ua'
class NativeBridge {
    static ACTION = {
        OPEN_SHARE: 'openShare',
        GOBACK: 'goBack',
    };

    static APP = {
        STORE: 'iCar_app'
    };

    static PLATFORM = {
        ANDROID: 'android',
        IOS: 'IOS'
    };

    info = {};

    constructor (nativeInfo) {
        this.info = nativeInfo
        window.invokeJS = this.invokeJS
    }
    invokeJS (actionJSON) {
        try {
            if (_.isString(actionJSON)) {
                const {
                    type,
                    data
                } = JSON.parse(actionJSON)
                eventBus.$emit(type, data)
            } else {
                const {
                    type,
                    data
                } = actionJSON
                eventBus.$emit(type, data)
            }
        } catch (err) {
            // 发生错误之后，不发送事件，让上层业务逻辑获取到 reject 请情况。
            // console.error(`${err.name}:${err.message}`)
        }
    }

    /**
     * 当前环境是否是养车app
     */
    isStore () {
        return this.info.app_name === NativeBridge.APP.STORE
    }
    /**
     *  统一区分platform
     * @param data 略
     */
    /**
     * 调用安卓暴露的方法
     * @param data 略
     */
    android (data) {
        window.carisok.globalEventNavigate(data)
    }
    /**
     * 调用 ios 暴露的方法
     * @param data 略
     */
    ios (data) {
        window.callNative(data)
    }
    /**
     * v3.3 以上ios换方法
     * @param data 略
     */
    iosUp (data) {
        window.webkit.messageHandlers.callNative.postMessage(data)
    }
    /**
     * 调用分享
     * @param {data: Object} 参数对象，具体参数如下
     * @param {title: String} 标题
     * @param {desc: String} 描述
     * @param {img_url: String} 图片
     * @param {link: String} 链接
     */
    onShareSingle (data) {
        data.img_url = data.img_url || 'https://image.carisok.com/images/icar_app.png'
        if (isAndroid()) {
            window.android.shareAppMessage(JSON.stringify(data))
        } else if (isIOS()) {
            window.webkit.messageHandlers.shareAppMessage.postMessage(data)
        } else {
            throw new Error(`platform:iphone is not support. current only support android and ios`)
        }
    }
    /**
     * 跳转原生app秒杀商品详情页面
     * @param {data: Object} 参数对象，具体参数如下
     * @param {goods_id: String} 商品id
     * @param {store_id: String} 门店id
     */
    goAppGoodsDetail (data) {
        if (isAndroid()) {
            window.android.goGoodsDetail(JSON.stringify(data))
        } else if (isIOS()) {
            window.webkit.messageHandlers.goGoodsDetail.postMessage(data)
        } else {
            throw new Error(`platform:iphone is not support. current only support android and ios`)
        }
    }
}

export default NativeBridge
